<template>
    <div class="layout-same-select-pop">
        <div class="share-sspp-title">{{popTitle}}</div>
        <div class="share-sspp-list">
            <div class="share-sspp-item" v-for="data in selectedList" @click="clickSelectedItem(data)" v-bind:key="data.id">
                {{noteText}}{{data.name.slice(0, 8)}}({{data.sex}})
                <i class="iconfont icon-arrow-you share-sspp-icon"></i>
            </div>
        </div>
        <div class="share-cgpp-button" @click="saveToNew">{{buttonText}}</div>
    </div>
</template>

<script>
export default {
    name: 'VantSameSelectPop',
    props: {
        popTitle: {
            type: String,
            default() {
                return '已存在四柱相同的八字，请选择打开已有八字还是继续新建：'
            }
        },
        noteText: {
            type: String,
            default() {
                return '打开命主：'
            }
        },
        buttonText: {
            type: String,
            default() {
                return '创建新八字'
            }
        },
        selectedList: {
            type: Array,
            default() {
                return []
            }
        },
        itemFunc: {
            type: Function,
            default() {
                return function() {}
            }
        },
        saveFunc: {
            type: Function,
            default() {
                return function() {}
            }
        }
    },
    data() {
        return {}
    },
    methods: {
        clickSelectedItem(data) {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(data);
            }
        },
        saveToNew() {
            if(this.saveFunc && typeof(this.saveFunc) == 'function') {
                this.saveFunc();
            }
        }
    }
}
</script>